import { asArray } from "./as-array";

const groupBy = <Item, GroupKey extends PropertyKey>(
    list: Item[],
    groupBy: (t: Item) => GroupKey[] | GroupKey
): Map<GroupKey, Item[]> => {
    const grouped = list.reduce((output, current) => {
        const keys = asArray(groupBy(current));
        for (const key of keys) {
            const values = output.get(key) ?? [];
            values.push(current);
            output.set(key, values);
        }
        return output;
    }, new Map<GroupKey, Item[]>());
    return grouped;
};

export { groupBy };
